import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const InventoryIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"inventory"} ref={ref}/>
});

InventoryIcon.displayName = "InventoryIcon";
